import React from "react";
import { whypageBanner } from "../..";

function BannerRightBox() {
  return (
    <div className="innerRightWrap">
      <img src={whypageBanner} alt="Vodote Techa" className="img-fluid" />
      <div className="overlayTextWrap">
        <p>Securing businesses with passion, precision, and purpose.</p>
        <h6>Soumik Mishra</h6>
        <span>Founder & CEO of Vodote Techa</span>
      </div>
    </div>
  );
}

export default BannerRightBox;
